import { sanitize } from 'core-components/helpers/sanitize'
import { getFormatDate } from 'src/core/classes/helpers/DateHelper'

const cleanValue = (value: unknown): unknown => {
  if (typeof value === 'string') {
    return value
      .replace(/[\r\n]/g, '')
      .replace(/[<>]/g, '')
      .trim()
  } else if (Array.isArray(value)) {
    return value.map(cleanValue)
  } else if (typeof value === 'object' && value !== null) {
    const cleanedObj: Record<string, unknown> = {}
    for (const [key, val] of Object.entries(value)) {
      cleanedObj[key] = cleanValue(val)
    }
    return cleanedObj
  }
  return value
}

const prepareArgs = (args: unknown[]) => {
  const cleanedArgs = args.map(cleanValue)
  const data = sanitize([
    `${getFormatDate(new Date(), 'custom', 'DD.MM.YYYY | HH:mm:ss')}:`,
    ...cleanedArgs,
  ])
  return data
}

const Logger = {
  log: (...args: any[]) => console.log(...prepareArgs(args)),
  debug: (...args: any[]) => console.debug(...prepareArgs(args)),
  error: (...args: any[]) => console.error(...prepareArgs(args)),
  info: (...args: any[]) => console.info(...prepareArgs(args)),
  warn: (...args: any[]) => console.warn(...prepareArgs(args)),
  groupCollapsed: (name: string) => console.groupCollapsed(...prepareArgs([name])),
  groupEnd: () => console.groupEnd(),
}

export default Logger
